import type {
  BookStore,
  BookStoreRequest,
  ItemDetail,
  ItemExchange,
  Pagination,
  PaginationRequest,
  RecordItem,
  Redeemed,
  RedeemedDetail,
  TradingInfo,
  UnRedeemed
} from '@/models/interface/funCoin';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class FunCoinService extends ApiFactory {
  constructor() {
    super('FunCoin');
  }

  /**
   *  查詢 FUN Coin紀錄 未兌換的項目
   */
  getRecordItem(): Promise<ApiDataResponse<RecordItem[]>> {
    return super.get(`RuleType`);
  }
  /**
   *  查看點數餘額
   */
  checkBalance(): Promise<ApiDataResponse<number>> {
    return super.get(`Balance`);
  }
  /**
   *  未兌換紀錄
   */
  unRedeemedList(data: PaginationRequest): Promise<ApiDataResponse<UnRedeemed>> {
    return super.post(`Point/Additions`, {
      typeId: null,
      paginationParamsDto: data
    });
  }
  /**
   *  已兌換紀錄
   */
  redeemedList(data: PaginationRequest): Promise<ApiDataResponse<Redeemed>> {
    return super.post(`Point/Deductions`, {
      paginationParamsDto: data
    });
  }
  /**
   *  已兌換紀錄明細 timestamp 只有日期而已
   */
  redeemedDetailList(timestamp: number): Promise<ApiDataResponse<RedeemedDetail[]>> {
    return super.post(`Point/HistoryByTimestamp`, { timestamp });
  }
  /**
   * 書店清單
   * @param itemClassId 1 學習類 2 生活類 4 課本類
   * @returns
   */
  getBookStoreList(data: BookStoreRequest): Promise<ApiDataResponse<BookStore>> {
    return super.post(`Display/ItemsByClassId`, data);
  }
  /**
   * 取得商品資訊
   * @param ID
   * @returns
   */
  getItemDetail(id: number): Promise<ApiDataResponse<ItemDetail>> {
    return super.get(`ItemPreviewById/${id}`);
  }
  /**
   * 上次交易紀錄資訊
   * @returns
   */
  getTradingInfo(): Promise<ApiDataResponse<TradingInfo>> {
    return super.get(`ItemExchange`);
  }
  /**
   * 兌換商品
   * @returns
   */
  itemExchange(data: ItemExchange): Promise<ApiDataResponse<number>> {
    return super.post(`ItemExchange`, data);
  }
  /**
   * 兌換現金
   * @returns
   */
  cashExchange(data: FormData): Promise<ApiDataResponse<number>> {
    return super.post(`CashExchange`, data);
  }
   /**
   * 取得ＭＧＭ碼
   * @returns
   */
   mgmCode(): Promise<ApiDataResponse<string>> {
    return super.get(`Code`);
  }
}
